import React, { Component } from 'react';
import { Link } from 'react-router-dom';
import moment from 'moment';

import { prettyKey } from 'helpers/formatters';

import { DATE_TIME_FORMAT } from '../../constants';
import withPreactivation from 'decorators/withPreactivation';

export class ViewPreactivation extends Component {
  componentDidMount() {
    this.fetchData();
  }

  componentDidUpdate(oldProps) {
    if (this.props.preactivationId !== oldProps.preactivationId) {
      this.fetchData();
    }

    if (!oldProps.preactivation && this.props.preactivation) {
      const userId = this.props.preactivation.user_profile;
      if (userId) {
        this.props.findUser(userId);
      }
    }
  }

  get isEdited() {
    const { preactivation } = this.props;

    return preactivation.old_account_number && preactivation.old_pin;
  }

  fetchData() {
    const { preactivationId, findPreactivation } = this.props;
    findPreactivation(preactivationId);
  }

  render() {
    const { preactivation } = this.props;
    if (!preactivation) {
      return null;
    }

    return (
      <div className="PreactivationList">
        <h1>Preactivation details</h1>
        <table className="table">
          <tbody>
            {this.isEdited && (
              <tr>
                <td>Edited</td>
                <td>
                  <span className="glyphicon glyphicon-ok text-success"></span>
                </td>
              </tr>
            )}
            {[
              'id',
              'first_name',
              'last_name',
              'mdn',
              'icc_id',
              'eid',
              'device_id',
              'carrier',
              'device_make',
              'device_storage',
              'device_model',
              'device_color',
              'old_account_number',
              'old_pin',
              'plan',
              'user_profile',
              'alternate_contact_number',
            ].map((attr) => (
              <tr key={attr}>
                <td>{prettyKey(attr)}</td>
                <td>{preactivation[attr]}</td>
              </tr>
            ))}
            <tr>
              <td>Created at</td>
              <td>
                {moment(preactivation.created_at).format(DATE_TIME_FORMAT)}
              </td>
            </tr>
          </tbody>
        </table>
        <div>
          <Link
            className="btn btn-primary"
            to={`/users/${preactivation.user_profile}/att/new-subscription?preactivation=${preactivation.id}`}
          >
            Create AT&amp;T Subscription
          </Link>
          <Link
            className="btn btn-primary mar-l"
            to={`/users/${preactivation.user_profile}/quick/new-subscription?preactivation=${preactivation.id}`}
          >
            Create Quick Subscription
          </Link>
        </div>
      </div>
    );
  }
}

export default withPreactivation(ViewPreactivation);
